import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-errordialog',
  templateUrl: './errordialog.component.html',
  styleUrls: ['./errordialog.component.scss']
})
export class ErrordialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
